import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "antd";

import { actions } from "store";
import { SalonForm, SalonList } from "components/blocks/Salon";
import { SitePageForm } from 'components/blocks/Site';


class SalonListScreen extends Component {
  render() {
    const { site, history } = this.props;
    const detail = site.detail;

    return (
      <Fragment>
        <div className="page-content page-content-full">
          <div className="page-block page-block-full">
            {detail &&
            <SalonList
              history={history}
              activeFilter={{ site: detail.id }}
              topActions={[
                <Button type="primary" className="" icon="plus" onClick={() => this.showForm()}>
                  Добавить анкету
                </Button>
              ]}
            />}
          </div>
        </div>

        {detail &&
        <SalonForm siteId={detail.id}/>}

        {detail &&
        <SitePageForm siteId={detail.id}/>}
      </Fragment>
    );
  }
}


function mapStateToProps(state) {
  return {
    site: state.site,
    salon: state.salon,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.salon), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalonListScreen);
